module.exports = __webpack_public_path__ + "img/water-trash.a4e079fe.png";